import * as THREE from 'three'

import {
  DEFAULT_EQUIPMENT,
  kaykitCosmeticMeshMatchers,
  type AvatarEquipment,
} from '../model/kaykitEquipment'

function applyCosmetics(root: THREE.Object3D, characterId: string, eq: AvatarEquipment): void {
  const matchers = kaykitCosmeticMeshMatchers(characterId)
  root.traverse((obj) => {
    if (!(obj as { isMesh?: boolean }).isMesh) return
    const mesh = obj as THREE.Object3D & { name: string; visible: boolean }
    const n = mesh.name
    const isExtra = matchers.extra.some((m) => n.includes(m))
    const isHat =
      !isExtra &&
      matchers.hat.some((m) => {
        if (m === 'Helmet') return n.includes('Helmet') && !n.includes('Visor')
        return n.includes(m)
      })
    const isCape = matchers.cape.some((m) => n.includes(m))
    if (isExtra) {
      mesh.visible = eq.showExtra
      return
    }
    if (isHat) {
      mesh.visible = eq.showHat
      return
    }
    if (isCape) mesh.visible = eq.showCape
  })
}

/** Toggle KayKit cosmetic meshes (hat / cape / extra). Hand props removed. */
export async function applyKayKitEquipment(
  characterRoot: THREE.Object3D,
  characterId: string,
  equipment?: Partial<AvatarEquipment> | null,
): Promise<void> {
  const eq: AvatarEquipment = { ...DEFAULT_EQUIPMENT, ...equipment }
  applyCosmetics(characterRoot, characterId, eq)
}
